import { SIP_CLIENT_ACTIONS } from '../../constants.js';

export function hangUpFromSip() {
	return {
		type: SIP_CLIENT_ACTIONS.HANGUP
	};
}

export function streamFromSip(data) {
	return {
		type: SIP_CLIENT_ACTIONS.STREAM,
		data: data
	};
}



// WEBPACK FOOTER //
// ./src/redux/actions/A_sip_client_actions.js